module.exports = __webpack_public_path__ + "static/img/banner_bms.b30a893.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_bms.jpg
// module id = Xxev
// module chunks = 15